export default (state = [], action) => {
  switch (action.type) {
    case 'TOGGLE_MOBILE_NAV':
      return {
        ...state,
        isMobileNavOpen: !state.isMobileNavOpen,
      };
    default:
      return state;
  }
};
